<div class="rp-shell">
  <div class="rp-header">
    <div class="rp-icon">
      <mat-icon>event_repeat</mat-icon>
    </div>
    <div class="rp-header-text">
      <div class="rp-title">
        ¿Cuántas semanas repetir el patrón
        <span class="rp-pattern-name" [style.color]="data.patternColor">{{ data.patternName }}</span>?
      </div>
      <div class="rp-subtitle">
        A partir de la semana <strong>{{ data.weekRangeLabel }}</strong>
      </div>
    </div>
  </div>

  <div class="rp-day-strip">
    <span
      class="rp-day-chip"
      *ngFor="let day of data.days"
      [style.background]="chipBackground(day.color)"
      [style.color]="day.color"
    >
      {{ day.letter }}
    </span>
  </div>

  <div class="rp-stepper">
    <button
      type="button"
      class="rp-stepper-btn"
      [disabled]="weeks <= minWeeks"
      (click)="decrement()"
    >
      <mat-icon>remove</mat-icon>
    </button>

    <div class="rp-stepper-value">
      <input
        type="number"
        [min]="minWeeks"
        [max]="maxWeeks"
        [(ngModel)]="weeks"
        (ngModelChange)="clampWeeks()"
      />
      <span>semanas</span>
    </div>

    <button
      type="button"
      class="rp-stepper-btn"
      [disabled]="weeks >= maxWeeks"
      (click)="increment()"
    >
      <mat-icon>add</mat-icon>
    </button>
  </div>

  <div class="rp-range-hint">Hasta el {{ endDateLabel }}</div>

  <div class="rp-presets">
    <button type="button" class="rp-preset-btn" [class.rp-preset-btn--active]="weeks === 1" (click)="setWeeks(1)">1 sem</button>
    <button type="button" class="rp-preset-btn" [class.rp-preset-btn--active]="weeks === 2" (click)="setWeeks(2)">2 sem</button>
    <button type="button" class="rp-preset-btn" [class.rp-preset-btn--active]="weeks === 4" (click)="setWeeks(4)">4 sem</button>
    <button type="button" class="rp-preset-btn" [class.rp-preset-btn--active]="weeks >= 5" (click)="setWeeks(5)">5 sem o más</button>
  </div>

  <div class="rp-actions">
    <button type="button" class="rp-btn-cancel" (click)="cancel()">Cancelar</button>
    <button type="button" class="rp-btn-apply" (click)="apply()">Aplicar</button>
  </div>
</div>
